// extracted by mini-css-extract-plugin
module.exports = {"menuBg":"#41949f","menuText":"#bfcbd9","menuActiveText":"#f4f4f5"};